module.exports = __webpack_public_path__ + "img/IMG_1444_L_Foamcore.9343938d.jpg";